<template>
  <div v-loading="loading">
    <el-row v-if="info" style="height: 30px; border-bottom: 1px solid #ddd">
      <el-col :span="22"> 代采订单详情 </el-col>
      <!--<el-button type="danger" size="mini" @click="handleEdit()"  v-show="(info.cg_type == 2 || info.cg_type == 1 || info.cg_type == 4) && info.status == 10">重新编辑</el-button>-->
    </el-row>
    <!-- <el-row style="height: 80px;" type="flex" align="middle" justify="center" v-if="info">
            <el-col :span="24">
                <el-steps space="100%" :active="steps_label.index" finish-status="success" :process-status="steps_label.processStatus" align-center>
                    <el-step :title="step.title" :description="step.description" v-for="(step, index) in steps_label.steps" :key="index"></el-step>
                </el-steps>
            </el-col>
        </el-row> -->
    <el-row>
      <el-col v-if="info" :span="24">
        <el-alert
          :title="`当前代采订单状态：${info.status_label || '--'};  交易方式：${
            info.wcg_order_cg_type || '--'
          };   支付方式：${info.wcg_order_pay_tool || '--'}`"
          :type="
            info && info.status >= 2 && info.status < 9 && info.status != 5
              ? 'success'
              : 'error'
          "
          :closable="false"
        >
        </el-alert>
      </el-col>
    </el-row>
    <el-row style="border: 1px solid #ddd">
      <el-col v-if="info" :span="24">
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
          "
          :span="24"
        >
          基本信息
        </div>
        <el-table
          v-show="info.status < 2 || info.status == 9"
          :key="'table5'"
          :data="[info]"
          border
          style="width: 100%"
        >
          <el-table-column prop="woid" label="代采订单编号" align="center">
          </el-table-column>
          <el-table-column prop="sumNum" label="代采数量" align="center">
          </el-table-column>
          <el-table-column
            prop="market_nikename"
            label="市场/子市场"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="supply_name" label="档口号" align="center">
          </el-table-column>
          <el-table-column prop="pgname" label="代采组" align="center">
          </el-table-column>
          <el-table-column prop="create_time" label="提交时间" align="center">
          </el-table-column>
          <el-table-column prop="pay_time" label="支付时间" align="center">
          </el-table-column>
        </el-table>
        <el-table
          v-show="info.status >= 2 && info.status != 9"
          :key="'table6'"
          :data="[info]"
          border
          style="width: 100%"
        >
          <el-table-column prop="woid" label="代采订单编号" align="center">
          </el-table-column>
          <el-table-column prop="sumNum" label="代采数量" align="center">
          </el-table-column>
          <el-table-column prop="dk_num" label="前置数量" align="center">
          </el-table-column>
          <el-table-column prop="wdd_num" label="抵扣数量" align="center">
          </el-table-column>
          <el-table-column
            prop="market_nikename"
            label="市场/子市场"
            align="center"
          >
          </el-table-column>
          <el-table-column prop="supply_name" label="商家" align="center">
          </el-table-column>
          <el-table-column prop="pgname" label="代采组" align="center">
          </el-table-column>
          <el-table-column
            prop="create_time"
            label="提交时间"
            align="center"
            width="200"
          >
          </el-table-column>
          <el-table-column
            prop="pay_time"
            label="支付时间"
            align="center"
            width="210"
          >
            <template
              v-if="info.status >= 2 && info.status < 9"
              #default="scope"
            >
              <el-date-picker
                v-show="index == scope.$index"
                v-model="paytime"
                type="datetime"
                :placeholder="scope.row.pay_time"
                align="center"
                size="mini"
                style="width: 100%"
              >
              </el-date-picker>
              <div v-show="index !== scope.$index">
                {{ scope.row.pay_time }}
              </div>
              <span
                style="color: #409eff; cursor: pointer"
                @click="updatePaytime(scope.$index)"
                >{{ index == scope.$index ? "完成" : "修改" }}</span
              >
            </template>
          </el-table-column>
          <!-- <el-table-column prop="create_price" label="代采金额" align="center">
          </el-table-column>
          <el-table-column prop="" label="活动服务费" align="center">
            <template slot-scope="scope">
              <div>
                {{ scope.row.activity_price }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="dk_amount" label="前置金额" align="center">
          </el-table-column>
          <el-table-column
            prop="ded_activity_fee"
            label="活动费用抵扣金额"
            align="center"
          >
            <template #default>
              <span style="color: red">{{
                info.ext && info.ext.ded_activity_fee
              }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="ded_price" label="商品抵扣金额" align="center">
          </el-table-column>

          <el-table-column prop="diff_price" label="差价" align="center">
          </el-table-column>
          <el-table-column prop="order_price" label="其他费用" align="center">
          </el-table-column>
          <el-table-column prop="pay_price" label="实付金额" align="center">
          </el-table-column> -->
        </el-table>
      </el-col>
    </el-row>
    <!-- 单据信息等 -->
    <!--普通代采单-->
    <div v-if="source == 1">
      <el-row v-if="info && (info.status < 2 || info.status == 9)" :gutter="20">
        <el-col :span="10" style="position: relative; height: 100%">
          <div class="card-title">单据信息 {{ info.docs.length }}张</div>
          <div v-if="!isXhhk(info.cg_type) || dialogVisible1">
            <viewer class="viewer" :images="info.docs">
              <img
                v-for="src in info.docs"
                :key="src"
                :src="src"
                style="max-width: 100%; max-height: 100%"
              />
            </viewer>
          </div>
          <div
            v-if="isXhhk(info.cg_type) && !dialogVisible1"
            style="margin-top: 30%"
          >
            <div style="color: red; text-align: center">
              <p>注意！</p>
              <p>
                此代采单属于先货后款类型只需审核商品数量与金额，无需银行转账
              </p>
            </div>
            <el-button
              type="primary"
              size="small"
              style="text-align: center; margin-left: 40%"
              @click="showXhhkReceipt"
              >查看代采单据</el-button
            >
          </div>
        </el-col>
        <el-col :span="14">
          <el-row>
            <el-col v-if="info.is_new == 1">
              <div class="card-title">商品信息</div>
              <el-table
                :data="info.new_goods_list.list"
                border
                style="width: 100%"
                height="750"
              >
                <el-table-column
                  prop="goods_name"
                  label="代采计划"
                  align="center"
                >
                  <template #default="scope">
                    <p>{{ scope.row.planid }}</p>
                    <p>{{ scope.row.wcg_plan_ptype }}</p>
                    <p>{{ scope.row.create_time }}</p>
                    <p style="color: red">
                      {{ scope.row.goods_type }}
                    </p>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="goods_name"
                  label="商品名称"
                  align="center"
                >
                </el-table-column>
                <el-table-column prop="goods_no" label="货号" align="center">
                </el-table-column>
                <el-table-column prop="co_val" label="颜色" align="center">
                </el-table-column>
                <el-table-column prop="si_val" label="尺码" align="center">
                </el-table-column>
                <el-table-column prop="brand_name" label="品牌" align="center">
                </el-table-column>
                <el-table-column prop="num" label="实际数量" align="center">
                </el-table-column>
                <el-table-column
                  prop="addedNum"
                  label="前置数量"
                  align="center"
                >
                  <template #default="scope">
                    <span v-if="scope.row.dk_num > 0" style="color: red">{{
                      scope.row.dk_num
                    }}</span>
                    <span v-else>0</span>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="plan_price"
                  label="商家价"
                  align="center"
                >
                </el-table-column>
                <el-table-column prop="price" label="代采价" align="center">
                  <template #default="scope">
                    <input
                      v-model="scope.row.price"
                      type="text"
                      style="
                        width: 100%;
                        text-align: center;
                        font-size: 14px;
                        border: 0;
                      "
                      :style="{
                        color:
                          Number(scope.row.price) ==
                          Number(scope.row.plan_price)
                            ? '#606266'
                            : '#FF4040',
                      }"
                      @blur="update(scope.row.price, scope.$index)"
                      @focus="initData = scope.row.price"
                    />
                  </template>
                </el-table-column>

                <el-table-column prop="total" label="开单价小计" align="center">
                </el-table-column>
                <el-table-column
                  prop="activity_fee"
                  label="活动服务费小计"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="service_fee"
                  :label="`佣金小计(${info.ext && info.ext.service_fee_rate}%)`"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="dispense_commission_amount"
                  label="小店佣金"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="refund_service_fee"
                  :label="`退货服务费小计(${
                    info.ext && info.ext.refund_service_fee_rate
                  }%)`"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="true_total"
                  label="实付金额小计"
                  align="center"
                >
                </el-table-column>
              </el-table>
              <div
                style="
                  text-align: right;
                  height: 40px;
                  background: #f3f3f3;
                  line-height: 40px;
                  padding: 0 40px;
                  font-size: 14px;
                  color: #ff4040;
                "
              >
                合计代采金额： ¥{{ info.sumPrice }}
              </div>
            </el-col>
          </el-row>
          <el-row>
            <el-col>
              <div class="card-title">代采备注</div>
              <div v-if="info" style="border: 1px solid #ddd; padding: 15px">
                <el-input
                  v-model="info.note"
                  type="textarea"
                  :rows="2"
                  placeholder="暂无备注信息"
                  disabled
                  class="pay-comment"
                >
                </el-input>
              </div>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="24" style="margin: 20px 0">
          <!-- ------------ todo ---------- -->
          <div
            class="card-title"
            @click="toggleFilter('activityServiceTogglle')"
          >
            <el-button
              type="text"
              style="margin-left: auto"
              :icon="
                toggle.activityServiceTogglle
                  ? 'el-icon-arrow-down'
                  : 'el-icon-arrow-up'
              "
            ></el-button>
            活动服务费商品
          </div>
          <el-collapse-transition>
            <div v-show="toggle.activityServiceTogglle">
              <el-table :data="activity_fee_detail.list" :span-method="rowSpan">
                <el-table-column
                  prop="special_start_time"
                  label="专场开始时间"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="goods_name"
                  label="商品名称"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="goods_no"
                  label="货号"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="co_val"
                  label="颜色"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="si_val"
                  label="尺码"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="price"
                  label="拿货单价"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="num"
                  label="开单数量"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="activity_time"
                  label="活动时间"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="activity_id"
                  label="活动ID"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="activity_type"
                  label="活动类型"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="activity_name"
                  label="活动名称"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="discount_shop_price"
                  label="小计"
                  align="center"
                ></el-table-column>
              </el-table>
              <div
                style="
                  text-align: right;
                  height: 40px;
                  background: #f3f3f3;
                  line-height: 40px;
                  padding: 0 40px;
                  font-size: 14px;
                  color: #ff4040;
                "
              >
                活动服务费： ¥{{ info.activity_price }}
              </div>
            </div>
          </el-collapse-transition>
        </el-col>
        <el-col :span="24" style="margin-bottom: 20px">
          <div
            class="card-title"
            style="
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: space-between;
            "
            @click="toggleFilter('activityCostTogglle')"
          >
            <div>
              <el-button
                type="text"
                style="margin-left: auto"
                :icon="
                  toggle.activityCostTogglle
                    ? 'el-icon-arrow-down'
                    : 'el-icon-arrow-up'
                "
              ></el-button
              >活动费抵扣商品
            </div>

            <el-button size="small" type="success" @click="exportActivityGoods">
              导出
            </el-button>
          </div>
          <el-collapse-transition>
            <div v-show="toggle.activityCostTogglle">
              <el-table :data="activityGoodsInfo" border>
                <el-table-column
                  label="活动时间"
                  prop="activity_time"
                  align="center"
                ></el-table-column>
                <el-table-column
                  label="商品名称"
                  prop="goods_name"
                  align="center"
                ></el-table-column>
                <el-table-column
                  label="货号"
                  prop="goods_no"
                  align="center"
                ></el-table-column>
                <el-table-column
                  label="颜色/尺码"
                  prop="co_si"
                  align="center"
                ></el-table-column>
                <el-table-column
                  label="SKU编号"
                  prop="sku"
                  align="center"
                ></el-table-column>
                <el-table-column
                  label="单件优惠额"
                  prop="activity_fee"
                  align="center"
                ></el-table-column>
                <el-table-column
                  label="抵扣数量"
                  prop="num"
                  align="center"
                ></el-table-column>
                <el-table-column
                  label="订单ID"
                  prop="order_id"
                  align="center"
                ></el-table-column>
                <el-table-column
                  label="活动ID"
                  prop="activity_id"
                  align="center"
                ></el-table-column>
                <el-table-column
                  label="活动类型"
                  prop="activity_type_text"
                  align="center"
                ></el-table-column>
                <el-table-column
                  label="活动名称"
                  prop="activity_name"
                  align="center"
                ></el-table-column>
                <el-table-column
                  label="活动费抵扣小计"
                  prop="activity_fee_amount"
                  align="center"
                ></el-table-column>
              </el-table>
              <div
                style="
                  text-align: right;
                  height: 40px;
                  background: #f3f3f3;
                  line-height: 40px;
                  padding: 0 40px;
                  font-size: 14px;
                  color: #ff4040;
                "
              >
                <div>合计活动费抵扣金额：¥{{ activity_fee_amount }}</div>
              </div>
            </div>
          </el-collapse-transition>
        </el-col>

        <el-col :span="24" style="margin-bottom: 20px">
          <div
            class="card-title"
            @click="toggleFilter('concedeBenefitsToggle')"
          >
             
            <el-button
              type="text"
              style="margin-left: auto"
              :icon="
                toggle.concedeBenefitsToggle
                  ? 'el-icon-arrow-down'
                  : 'el-icon-arrow-up'
              "
            ></el-button>
            让利佣金账单抵扣明细
          </div>
          <el-collapse-transition>
            <div v-show="toggle.concedeBenefitsToggle">
              <el-table
                :data="rebateData.list"
                border
                style="width: 100%"
                height="200"
              >
                <el-table-column
                  prop="reporting_period"
                  label="让利账期"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="bill_no"
                  label="让利账单编号"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="confirm_time"
                  label="让利账单确认时间"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="amount_price"
                  label="总结算金额"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="deduction_price"
                  label="本单让利佣金抵扣金额"
                  align="center"
                >
                </el-table-column>
              </el-table>
              <div
                style="
                  text-align: right;
                  height: 40px;
                  background: #f3f3f3;
                  line-height: 40px;
                  padding: 0 40px;
                  font-size: 14px;
                  color: #ff4040;
                "
              >
                合计让利佣金抵扣金额： ¥{{ rebateData.total }}
              </div>
            </div>
          </el-collapse-transition>
        </el-col>
        <el-col :span="24" style="margin-bottom: 20px">
          <div class="card-title" @click="toggleFilter('goodsToggle')">
            <el-button
              type="text"
              style="margin-left: auto"
              :icon="
                toggle.goodsToggle ? 'el-icon-arrow-down' : 'el-icon-arrow-up'
              "
            ></el-button>
            商品抵扣列表
          </div>
          <el-collapse-transition>
            <div v-show="toggle.goodsToggle">
              <el-table
                :data="info.ded.goodsList"
                border
                style="width: 100%"
                height="200"
              >
                <el-table-column
                  prop="goods_name"
                  label="商品名称"
                  align="center"
                >
                </el-table-column>
                <el-table-column prop="goods_no" label="货号" align="center">
                </el-table-column>
                <el-table-column prop="co_val" label="颜色" align="center">
                </el-table-column>
                <el-table-column prop="si_val" label="尺码" align="center">
                </el-table-column>
                <el-table-column prop="address" label="品牌" align="center">
                </el-table-column>
                <el-table-column prop="address" label="买手组" align="center">
                </el-table-column>
                <el-table-column prop="num" label="数量" align="center">
                </el-table-column>
                <el-table-column prop="price" label="代采价" align="center">
                </el-table-column>
                <el-table-column
                  prop="status_label"
                  label="抵扣状态"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="sum_price"
                  label="抵扣金额"
                  align="center"
                >
                </el-table-column>
              </el-table>
              <div
                style="
                  text-align: right;
                  height: 40px;
                  background: #f3f3f3;
                  line-height: 40px;
                  padding: 0 40px;
                  font-size: 14px;
                  color: #ff4040;
                "
              >
                合计商品抵扣金额： ¥{{ info.ded.sumPrice }}
              </div>
            </div>
          </el-collapse-transition>
        </el-col>
      </el-row>
    </div>
    <!--爆版代采单 爆版pc开单来源source=5，爆版app开单来源source=2 -->
    <div v-if="['2', '5'].includes(source)">
      <el-row v-if="info && (info.status < 2 || info.status == 9)">
        <el-col v-if="info.is_new == 1" :span="24">
          <div class="card-title">商品信息</div>
          <el-table
            :data="info.new_goods_list.list"
            border
            style="width: 100%"
            height="750"
          >
            <el-table-column prop="goods_name" label="代采计划" align="center">
              <template #default="scope">
                <p>{{ scope.row.planid }}</p>
                <p>{{ scope.row.wcg_plan_ptype }}</p>
                <p>{{ scope.row.create_time }}</p>
                <p style="color: red">
                  {{ scope.row.goods_type }}
                </p>
              </template>
            </el-table-column>
            <el-table-column prop="goods_name" label="商品名称" align="center">
            </el-table-column>
            <el-table-column prop="goods_no" label="货号" align="center">
            </el-table-column>
            <el-table-column prop="co_val" label="颜色" align="center">
            </el-table-column>
            <el-table-column prop="si_val" label="尺码" align="center">
            </el-table-column>
            <el-table-column prop="brand_name" label="品牌" align="center">
            </el-table-column>
            <el-table-column prop="num" label="实际数量" align="center">
            </el-table-column>
            <el-table-column prop="addedNum" label="前置数量" align="center">
              <template #default="scope">
                <span v-if="scope.row.dk_num > 0" style="color: red">{{
                  scope.row.dk_num
                }}</span>
                <span v-else>0</span>
              </template>
            </el-table-column>
            <el-table-column prop="plan_price" label="商家价" align="center">
            </el-table-column>
            <el-table-column prop="price" label="代采价" align="center">
              <template #default="scope">
                <input
                  v-model="scope.row.price"
                  type="text"
                  style="
                    width: 100%;
                    text-align: center;
                    font-size: 14px;
                    border: 0;
                  "
                  :style="{
                    color:
                      Number(scope.row.price) == Number(scope.row.plan_price)
                        ? '#606266'
                        : '#FF4040',
                  }"
                  @blur="update(scope.row.price, scope.$index)"
                  @focus="initData = scope.row.price"
                />
              </template>
            </el-table-column>

            <el-table-column prop="total" label="开单价小计" align="center">
            </el-table-column>
            <el-table-column
              prop="activity_fee"
              label="活动服务费小计"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="service_fee"
              :label="`佣金小计(${info.ext && info.ext.service_fee_rate}%)`"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="dispense_commission_amount"
              label="小店佣金"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="refund_service_fee"
              :label="`退货服务费小计(${
                info.ext && info.ext.refund_service_fee_rate
              }%)`"
              align="center"
            >
            </el-table-column>
            <el-table-column
              prop="true_total"
              label="实付金额小计"
              align="center"
            >
            </el-table-column>
          </el-table>
          <div
            style="
              text-align: right;
              height: 40px;
              background: #f3f3f3;
              line-height: 40px;
              padding: 0 40px;
              font-size: 14px;
              color: #ff4040;
            "
          >
            合计代采金额： ¥{{ info.sumPrice }}
          </div>
        </el-col>
      </el-row>

      <el-row v-if="info && (info.status < 2 || info.status == 9)">
        <el-col :span="24" style="margin: 20px 0">
          <!-- ------------ todo ---------- -->
          <div
            class="card-title"
            @click="toggleFilter('activityServiceTogglle')"
          >
             
            <el-button
              type="text"
              style="margin-left: auto"
              :icon="
                toggle.activityServiceTogglle
                  ? 'el-icon-arrow-down'
                  : 'el-icon-arrow-up'
              "
            ></el-button>
            活动服务费商品
          </div>
          <el-collapse-transition>
            <div v-show="toggle.activityServiceTogglle">
              <el-table :data="activity_fee_detail.list" :span-method="rowSpan">
                <el-table-column
                  prop="special_start_time"
                  label="专场开始时间"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="goods_name"
                  label="商品名称"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="goods_no"
                  label="货号"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="co_val"
                  label="颜色"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="si_val"
                  label="尺码"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="price"
                  label="拿货单价"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="num"
                  label="开单数量"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="activity_time"
                  label="活动时间"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="activity_id"
                  label="活动ID"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="activity_type"
                  label="活动类型"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="activity_name"
                  label="活动名称"
                  align="center"
                ></el-table-column>
                <el-table-column
                  prop="discount_shop_price"
                  label="小计"
                  align="center"
                ></el-table-column>
              </el-table>

              <div
                style="
                  text-align: right;
                  height: 40px;
                  background: #f3f3f3;
                  line-height: 40px;
                  padding: 0 40px;
                  font-size: 14px;
                  color: #ff4040;
                "
              >
                活动服务费： ¥{{ info.activity_price }}
              </div>
            </div>
          </el-collapse-transition>
        </el-col>
        <el-col :span="24" style="margin-bottom: 20px">
          <div
            class="card-title"
            style="
              display: flex;
              flex-direction: row;
              align-items: center;
              justify-content: space-between;
            "
            @click="toggleFilter('activityCostTogglle')"
          >
            <div>
              <el-button
                type="text"
                style="margin-left: auto"
                :icon="
                  toggle.activityCostTogglle
                    ? 'el-icon-arrow-down'
                    : 'el-icon-arrow-up'
                "
              ></el-button
              >活动费抵扣商品
            </div>

            <el-button size="small" type="success" @click="exportActivityGoods">
              导出
            </el-button>
          </div>
          <el-collapse-transition>
            <div v-show="toggle.activityCostTogglle">
              <el-table :data="activityGoodsInfo" border>
                <el-table-column
                  label="活动时间"
                  prop="activity_time"
                  align="center"
                ></el-table-column>
                <el-table-column
                  label="商品名称"
                  prop="goods_name"
                  align="center"
                ></el-table-column>
                <el-table-column
                  label="货号"
                  prop="goods_no"
                  align="center"
                ></el-table-column>
                <el-table-column
                  label="颜色/尺码"
                  prop="co_si"
                  align="center"
                ></el-table-column>
                <el-table-column
                  label="SKU编号"
                  prop="sku"
                  align="center"
                ></el-table-column>
                <el-table-column
                  label="单件优惠额"
                  prop="activity_fee"
                  align="center"
                ></el-table-column>
                <el-table-column
                  label="抵扣数量"
                  prop="num"
                  align="center"
                ></el-table-column>
                <el-table-column
                  label="订单ID"
                  prop="order_id"
                  align="center"
                ></el-table-column>
                <el-table-column
                  label="活动ID"
                  prop="activity_id"
                  align="center"
                ></el-table-column>
                <el-table-column
                  label="活动类型"
                  prop="activity_type_text"
                  align="center"
                ></el-table-column>
                <el-table-column
                  label="活动名称"
                  prop="activity_name"
                  align="center"
                ></el-table-column>
                <el-table-column
                  label="活动费抵扣小计"
                  prop="activity_fee_amount"
                  align="center"
                ></el-table-column>
              </el-table>
              <div
                style="
                  text-align: right;
                  height: 40px;
                  background: #f3f3f3;
                  line-height: 40px;
                  padding: 0 40px;
                  font-size: 14px;
                  color: #ff4040;
                "
              >
                <div>合计活动费抵扣金额：¥{{ activity_fee_amount }}</div>
              </div>
            </div>
          </el-collapse-transition>
        </el-col>
        <el-col :span="24" style="margin-bottom: 20px">
          <div
            class="card-title"
            @click="toggleFilter('concedeBenefitsToggle')"
          >
             
            <el-button
              type="text"
              style="margin-left: auto"
              :icon="
                toggle.concedeBenefitsToggle
                  ? 'el-icon-arrow-down'
                  : 'el-icon-arrow-up'
              "
            ></el-button>
            让利佣金账单抵扣明细
          </div>
          <el-collapse-transition>
            <div v-show="toggle.concedeBenefitsToggle">
              <el-table
                :data="rebateData.list"
                border
                style="width: 100%"
                height="200"
              >
                <el-table-column
                  prop="reporting_period"
                  label="让利账期"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="bill_no"
                  label="让利账单编号"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="confirm_time"
                  label="让利账单确认时间"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="amount_price"
                  label="总结算金额"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="deduction_price"
                  label="本单让利佣金抵扣金额"
                  align="center"
                >
                </el-table-column>
              </el-table>
              <div
                style="
                  text-align: right;
                  height: 40px;
                  background: #f3f3f3;
                  line-height: 40px;
                  padding: 0 40px;
                  font-size: 14px;
                  color: #ff4040;
                "
              >
                合计让利佣金抵扣金额： ¥{{ rebateData.total }}
              </div>
            </div>
          </el-collapse-transition>
        </el-col>
        <el-col :span="24">
          <div class="card-title" @click="toggleFilter('goodsToggle')">
            <el-button
              type="text"
              style="margin-left: auto"
              :icon="
                toggle.goodsToggle ? 'el-icon-arrow-down' : 'el-icon-arrow-up'
              "
            ></el-button>
            商品抵扣列表
          </div>
          <el-collapse-transition>
            <div v-show="toggle.goodsToggle">
              <el-table
                :key="'table2'"
                :data="info.ded.goodsList"
                border
                style="width: 100%"
                height="400"
              >
                <el-table-column prop="img" label="商品图片" align="center">
                  <template #default="scope">
                    <div
                      v-viewer
                      style="
                        width: 40px;
                        height: 40px;
                        overflow: hidden;
                        cursor: pointer;
                      "
                    >
                      <img
                        style="width: 100%; height: 100%"
                        :src="scope.row.img"
                      />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column
                  prop="goods_name"
                  label="商品名称"
                  align="center"
                >
                </el-table-column>
                <el-table-column prop="goods_no" label="货号" align="center">
                </el-table-column>
                <el-table-column prop="co_val" label="颜色" align="center">
                </el-table-column>
                <el-table-column prop="si_val" label="尺码" align="center">
                </el-table-column>
                <el-table-column prop="brand_name" label="品牌" align="center">
                </el-table-column>
                <el-table-column prop="pg_name" label="买手组" align="center">
                </el-table-column>
                <el-table-column prop="num" label="数量" align="center">
                </el-table-column>
                <el-table-column prop="price" label="代采价" align="center">
                </el-table-column>
                <el-table-column
                  prop="status_label"
                  label="抵扣状态"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="remainderPrice"
                  label="剩余金额"
                  align="center"
                >
                </el-table-column>
                <el-table-column
                  prop="sum_price"
                  label="抵扣金额"
                  align="center"
                >
                </el-table-column>
              </el-table>
              <div
                style="
                  text-align: right;
                  height: 40px;
                  background: #f3f3f3;
                  line-height: 40px;
                  padding: 0 40px;
                  font-size: 14px;
                  color: #ff4040;
                "
              >
                合计商品抵扣金额： ¥{{ info.ded.sumPrice }}
              </div>
            </div>
          </el-collapse-transition>
        </el-col>
      </el-row>
      <el-row>
        <el-col>
          <div class="card-title">代采备注</div>
          <div
            v-if="info"
            style="border: 1px solid #ddd; padding: 15px; height: 218px"
          >
            <el-input
              v-model="info.note"
              type="textarea"
              :rows="9"
              placeholder="暂无备注信息"
              disabled
              class="pay-comment"
            >
            </el-input>
          </div>
        </el-col>
      </el-row>
    </div>

    <el-row v-if="info">
      <el-col>
        <div class="card-title">金额信息</div>
        <el-table :data="[info]" border style="width: 100%">
          <el-table-column prop="create_price" label="代采金额" align="center">
          </el-table-column>
          <el-table-column label="活动服务费" align="center">
            <template #default="scope">
              {{ scope.row.activity_price }}
            </template>
          </el-table-column>
          <el-table-column
            :label="`佣金合计(${info.ext && info.ext.service_fee_rate}%)`"
            align="center"
          >
            <span>
              {{ info.ext && info.ext.service_fee }}
            </span>
          </el-table-column>
          <el-table-column label="小店佣金" align="center">
            <span>
              {{ info.ext && info.ext.dispense_commission_amount }}
            </span>
          </el-table-column>
          <el-table-column
            :label="`退货服务费合计(${
              info.ext && info.ext.refund_service_fee_rate
            }%)`"
            align="center"
          >
            <span>
              {{ info.ext && info.ext.refund_service_fee }}
            </span>
          </el-table-column>
          <el-table-column prop="ded_price" label="实付金额合计" align="center">
            <template #default="scope">
              <span style="color: red">{{ scope.row.true_price }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="ded_activity_fee"
            label="活动费抵扣金额"
            align="center"
          >
            <template #default>
              <span style="color: red">{{
                info.ext && info.ext.ded_activity_fee
              }}</span>
            </template>
          </el-table-column>
          <el-table-column label="让利佣金抵扣金额" align="center">
            <template #default>
              <span style="color: red">{{ rebateData.total || "" }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="ded_price" label="商品抵扣合计" align="center">
            <template #default="scope">
              <span style="color: red">{{ scope.row.ded_price }}</span>
            </template>
          </el-table-column>
          <el-table-column prop="pay_price" label="实际结算金额" align="center">
            <template #default="scope">
              <div style="color: red">
                {{ scope.row.pay_price }}
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row
      v-if="
        info && ((info.status >= 2 && info.status < 9) || info.status == 11)
      "
    >
      <el-col>
        <div class="card-title">单据信息</div>
        <table style="width: 100%; border-collapse: collapse; color: #606266">
          <tr style="height: 80px">
            <td
              style="
                width: 50%;
                border: 1px solid #ddd;
                border-collapse: collapse;
                text-align: center;
              "
            >
              代采单据（{{ info.docs.length }}张）
            </td>
            <td
              style="
                width: 50%;
                border: 1px solid #ddd;
                border-collapse: collapse;
                padding: 0 40px;
              "
            >
              <div
                v-viewer
                style="
                  width: 40px;
                  height: 40px;
                  overflow: hidden;
                  cursor: pointer;
                  display: inline-block;
                "
              >
                <img
                  v-for="(img, idx) in info.docs"
                  :key="idx"
                  :src="img"
                  style="width: 100%; height: 100%"
                />
              </div>
            </td>
          </tr>
          <tr v-if="info.status != 10" style="height: 80px">
            <td
              style="
                width: 50%;
                border: 1px solid #ddd;
                border-collapse: collapse;
                text-align: center;
              "
            >
              付款回执（{{ info.pay_docs.length }}张）
            </td>
            <td
              style="
                width: 50%;
                border: 1px solid #ddd;
                border-collapse: collapse;
                padding: 10px 40px;
              "
            >
              <div
                v-viewer
                style="
                  width: 40px;
                  height: 40px;
                  overflow: hidden;
                  cursor: pointer;
                  display: inline-block;
                  vertical-align: middle;
                  margin-right: 20px;
                "
              >
                <img
                  v-for="(img, idx) in info.pay_docs"
                  :key="idx"
                  :src="img"
                  style="width: 100%; height: 100%"
                />
              </div>
            </td>
          </tr>
        </table>
      </el-col>
    </el-row>
    <el-row>
      <el-col>
        <div class="card-title">付款信息</div>
        <el-table :key="'table4'" :data="[info]" border style="width: 100%">
          <el-table-column
            prop="pay_account"
            label="收款人银行账号"
            align="center"
          >
            <template v-if="info" #default="scope">
              <el-tag
                v-if="info.bank_is_verify == 1"
                type="warning"
                style="size: mini; color: #0e0e0e"
                >已验证</el-tag
              >
              {{ scope.row.pay_account }}
            </template>
          </el-table-column>
          <el-table-column prop="pay_contact" label="收款人姓名" align="center">
          </el-table-column>
          <el-table-column prop="pay_bank" label="收款人银行" align="center">
          </el-table-column>
          <el-table-column prop="cnap_name" label="收款银行支行" align="center">
          </el-table-column>
          <el-table-column label="操作" align="center">
            <!-- 20200521 代采邮件要求屏蔽 <template slot-scope="scope">
                        <el-button v-if="info && info.status != 12" size="small" type="primary" @click="update_payee">修改付款信息</el-button>
                        </template> -->
          </el-table-column>
          <!--<el-table-column prop="pay_desc" label="收款人信息" align="center">-->
          <!--</el-table-column>-->
          <el-table-column
            v-if="
              info && info.status == 1 && info.cg_type !== CG_TYPT_REGULAR_PICK
            "
            prop="address"
            :label="'付款回执（' + files.length + '张）'"
            align="center"
          >
            <template #default>
              <div>
                <el-upload
                  :action="action"
                  style="display: inline-block; margin-right: 10px"
                  multiple
                  accept="image/*"
                  :on-success="uploadSuccess"
                  :on-remove="handleRemove"
                  :limit="9"
                  :on-exceed="handleExceed"
                  :file-list="files"
                  with-credentials
                >
                  <el-button size="small" type="primary">上传回执</el-button>
                  <el-button
                    v-show="files.length > 0"
                    size="small"
                    type="success"
                    @click.stop="confirmUpload"
                    >完成</el-button
                  >
                </el-upload>
                <el-button
                  v-if="info && info.status == 1"
                  size="small"
                  type="danger"
                  @click="reject()"
                  >驳回</el-button
                >
              </div>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-row v-if="info && info.status >= 2 && info.status != 9">
      <el-col :span="24">
        <div class="card-title">商品信息</div>
        <el-table
          :key="'table1'"
          :data="info.new_goods_list.list"
          border
          style="width: 100%"
          height="400"
        >
          <el-table-column prop="goods_name" label="代采计划" align="center">
            <template #default="scope">
              <p>{{ scope.row.planid }}</p>
              <p>{{ scope.row.wcg_plan_ptype }}</p>
              <p>{{ scope.row.create_time }}</p>
              <p style="color: red">{{ scope.row.goods_type }}</p>
            </template>
          </el-table-column>
          <el-table-column prop="img" label="商品图片" align="center">
            <template #default="scope">
              <div
                v-viewer
                style="
                  width: 40px;
                  height: 40px;
                  overflow: hidden;
                  cursor: pointer;
                  margin: auto;
                "
              >
                <img
                  v-for="(item, idx) in scope.row.middle_img"
                  :key="idx"
                  style="max-width: 100%; max-height: 100%"
                  :src="item"
                />
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="goods_name" label="商品名称" align="center">
          </el-table-column>
          <el-table-column prop="goods_no" label="货号" align="center">
          </el-table-column>
          <el-table-column prop="co_val" label="颜色" align="center">
          </el-table-column>
          <el-table-column prop="si_val" label="尺码" align="center">
          </el-table-column>
          <el-table-column prop="brand_name" label="品牌" align="center">
          </el-table-column>
          <el-table-column prop="pg_name" label="买手组" align="center">
          </el-table-column>
          <el-table-column prop="num" label="数量" align="center">
          </el-table-column>
          <el-table-column prop="addedNum" label="前置数量" align="center">
            <template #default="scope">
              <span v-if="scope.row.addedNum > 0" style="color: red">{{
                scope.row.addedNum
              }}</span>
              <span v-else>0</span>
            </template>
          </el-table-column>
          <el-table-column prop="price" label="代采价" align="center">
            <template #default="scope">
              <input
                v-model="scope.row.price"
                type="text"
                style="
                  width: 100%;
                  text-align: center;
                  font-size: 14px;
                  border: 0;
                "
                @blur="update(scope.row.price, scope.$index)"
                @focus="initData = scope.row.price"
              />
            </template>
          </el-table-column>
          <!-- <el-table-column prop="sum_price" label="小计" align="center"></el-table-column> -->
          <el-table-column prop="total" label="开单价小计" align="center">
          </el-table-column>
          <el-table-column
            prop="activity_fee"
            label="活动服务费小计"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="service_fee"
            :label="`佣金小计(${info.ext && info.ext.service_fee_rate}%)`"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="dispense_commission_amount"
            label="小店佣金"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="refund_service_fee"
            :label="`退货服务费小计(${
              info.ext && info.ext.refund_service_fee_rate
            }%)`"
            align="center"
          >
          </el-table-column>
          <el-table-column
            prop="true_total"
            label="实付金额小计"
            align="center"
          >
          </el-table-column>
        </el-table>
        <div
          style="
            text-align: right;
            height: 40px;
            background: #f3f3f3;
            line-height: 40px;
            padding: 0 40px;
            font-size: 14px;
            color: #ff4040;
          "
        >
          合计代采金额： ¥{{ info.sumPrice }}
        </div>
      </el-col>
    </el-row>
    <el-row v-if="info && info.status >= 2 && info.status != 9">
      <el-col :span="24" style="margin: 20px 0">
        <!-- ------------ todo ---------- -->

        <div class="card-title" @click="toggleFilter('activityServiceTogglle')">
           
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="
              toggle.activityServiceTogglle
                ? 'el-icon-arrow-down'
                : 'el-icon-arrow-up'
            "
          ></el-button>
          活动服务费商品
        </div>
        <el-collapse-transition>
          <div v-show="toggle.activityServiceTogglle">
            <el-table :data="activity_fee_detail.list" :span-method="rowSpan">
              <el-table-column
                prop="special_start_time"
                label="专场开始时间"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="goods_name"
                label="商品名称"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="goods_no"
                label="货号"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="co_val"
                label="颜色"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="si_val"
                label="尺码"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="price"
                label="拿货单价"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="num"
                label="开单数量"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="activity_time"
                label="活动时间"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="activity_id"
                label="活动ID"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="activity_type"
                label="活动类型"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="activity_name"
                label="活动名称"
                align="center"
              ></el-table-column>
              <el-table-column
                prop="discount_shop_price"
                label="小计"
                align="center"
              ></el-table-column>
            </el-table>
            <div
              style="
                text-align: right;
                height: 40px;
                background: #f3f3f3;
                line-height: 40px;
                padding: 0 40px;
                font-size: 14px;
                color: #ff4040;
              "
            >
              活动服务费： ¥{{ info.activity_price }}
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
      <el-col :span="24" style="margin-bottom: 20px">
        <div
          class="card-title"
          style="
            display: flex;
            flex-direction: row;
            align-items: center;
            justify-content: space-between;
          "
          @click="toggleFilter('activityCostTogglle')"
        >
          <div>
            <el-button
              type="text"
              style="margin-left: auto"
              :icon="
                toggle.activityCostTogglle
                  ? 'el-icon-arrow-down'
                  : 'el-icon-arrow-up'
              "
            ></el-button
            >活动费抵扣商品
          </div>

          <el-button size="small" type="success" @click="exportActivityGoods">
            导出
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="toggle.activityCostTogglle">
            <el-table :data="activityGoodsInfo" border>
              <el-table-column
                label="活动时间"
                prop="activity_time"
                align="center"
              ></el-table-column>
              <el-table-column
                label="商品名称"
                prop="goods_name"
                align="center"
              ></el-table-column>
              <el-table-column
                label="货号"
                prop="goods_no"
                align="center"
              ></el-table-column>
              <el-table-column
                label="颜色/尺码"
                prop="co_si"
                align="center"
              ></el-table-column>
              <el-table-column
                label="SKU编号"
                prop="sku"
                align="center"
              ></el-table-column>
              <el-table-column
                label="单件优惠额"
                prop="activity_fee"
                align="center"
              ></el-table-column>
              <el-table-column
                label="抵扣数量"
                prop="num"
                align="center"
              ></el-table-column>
              <el-table-column
                label="订单ID"
                prop="order_id"
                align="center"
              ></el-table-column>
              <el-table-column
                label="活动ID"
                prop="activity_id"
                align="center"
              ></el-table-column>
              <el-table-column
                label="活动类型"
                prop="activity_type_text"
                align="center"
              ></el-table-column>
              <el-table-column
                label="活动名称"
                prop="activity_name"
                align="center"
              ></el-table-column>
              <el-table-column
                label="活动费抵扣小计"
                prop="activity_fee_amount"
                align="center"
              ></el-table-column>
            </el-table>

            <div
              style="
                text-align: right;
                height: 40px;
                background: #f3f3f3;
                line-height: 40px;
                padding: 0 40px;
                font-size: 14px;
                color: #ff4040;
              "
            >
              <div>合计活动费抵扣金额：¥{{ activity_fee_amount }}</div>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
      <el-col :span="24" style="margin-bottom: 20px">
        <div class="card-title" @click="toggleFilter('concedeBenefitsToggle')">
           
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="
              toggle.concedeBenefitsToggle
                ? 'el-icon-arrow-down'
                : 'el-icon-arrow-up'
            "
          ></el-button>
          让利佣金账单抵扣明细
        </div>
        <el-collapse-transition>
          <div v-show="toggle.concedeBenefitsToggle">
            <el-table
              :data="rebateData.list"
              border
              style="width: 100%"
              height="200"
            >
              <el-table-column
                prop="reporting_period"
                label="让利账期"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="bill_no"
                label="让利账单编号"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="confirm_time"
                label="让利账单确认时间"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="amount_price"
                label="总结算金额"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="deduction_price"
                label="本单让利佣金抵扣金额"
                align="center"
              >
              </el-table-column>
            </el-table>
            <div
              style="
                text-align: right;
                height: 40px;
                background: #f3f3f3;
                line-height: 40px;
                padding: 0 40px;
                font-size: 14px;
                color: #ff4040;
              "
            >
              合计让利佣金抵扣金额： ¥{{ rebateData.total }}
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
      <el-col :span="24">
        <div class="card-title" @click="toggleFilter('goodsToggle')">
           
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="
              toggle.goodsToggle ? 'el-icon-arrow-down' : 'el-icon-arrow-up'
            "
          ></el-button>
          商品抵扣列表
        </div>
        <el-collapse-transition>
          <div v-show="toggle.goodsToggle">
            <el-table
              :key="'table2'"
              :data="info.ded.goodsList"
              border
              style="width: 100%"
              height="400"
            >
              <el-table-column prop="img" label="商品图片" align="center">
                <template #default="scope">
                  <div
                    v-viewer
                    style="
                      width: 40px;
                      height: 40px;
                      overflow: hidden;
                      cursor: pointer;
                    "
                  >
                    <img
                      style="width: 100%; height: 100%"
                      :src="scope.row.img"
                    />
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="goods_name"
                label="商品名称"
                align="center"
              >
              </el-table-column>
              <el-table-column prop="goods_no" label="货号" align="center">
              </el-table-column>
              <el-table-column prop="co_val" label="颜色" align="center">
              </el-table-column>
              <el-table-column prop="si_val" label="尺码" align="center">
              </el-table-column>
              <el-table-column prop="brand_name" label="品牌" align="center">
              </el-table-column>
              <el-table-column prop="pg_name" label="买手组" align="center">
              </el-table-column>
              <el-table-column prop="num" label="数量" align="center">
              </el-table-column>
              <el-table-column prop="price" label="代采价" align="center">
              </el-table-column>
              <el-table-column
                prop="status_label"
                label="抵扣状态"
                align="center"
              >
              </el-table-column>
              <el-table-column
                prop="remainderPrice"
                label="剩余金额"
                align="center"
              >
              </el-table-column>
              <el-table-column prop="sum_price" label="抵扣金额" align="center">
              </el-table-column>
            </el-table>
            <div
              style="
                text-align: right;
                height: 40px;
                background: #f3f3f3;
                line-height: 40px;
                padding: 0 40px;
                font-size: 14px;
                color: #ff4040;
              "
            >
              合计商品抵扣金额： ¥{{ info.ded.sumPrice }}
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
    <!-- <el-row>
            <el-col>
                <div class="card-title">代采备注</div>
                <div style="border: 1px solid #ddd;padding:15px;" v-if="info">
                    <el-input type="textarea" :rows="9" placeholder="暂无备注信息" v-model="info.note" disabled class="pay-comment">
                    </el-input>
                </div>
            </el-col>
        </el-row> -->
    <el-row>
      <el-row>
        <div class="card-title">审核信息</div>
        <div v-if="pay_fail_msg.length > 0" class="card-warning">
          {{ pay_fail_msg }}
        </div>
        <el-row style="border: 1px solid #ddd; padding: 15px">
          <el-col
            :span="
              info && (info.status == 0 || info.status == 9 || info.status == 5)
                ? 20
                : 24
            "
            style="height: 200px"
          >
            <el-input
              v-model="textarea"
              type="textarea"
              :rows="9"
              placeholder="暂无备注信息"
              :disabled="
                info && info.status >= 2 && info.status != 5 && info.status != 9
              "
            >
            </el-input>
          </el-col>
          <el-col
            v-if="info && info.status == 0"
            :span="4"
            style="height: 200px"
          >
            <div
              style="
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                align-items: center;
                height: 100%;
              "
            >
              <div>
                <el-button class="btn-operation" type="success" @click="pass">
                  财务审核
                </el-button>
              </div>
              <!-- <div> //以后会用到
                                <el-button class="btn-operation" type="primary">提交</el-button>
                            </div> -->
              <div>
                <el-button class="btn-operation" type="danger" @click="reject">
                  驳回
                </el-button>
              </div>
              <!-- <div>  //以后会用到
                                <el-button class="btn-operation">取消</el-button>
                            </div> -->
            </div>
          </el-col>
          <el-col
            v-if="info && info.status == 9"
            :span="4"
            style="height: 200px"
          >
            <div
              style="
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                align-items: center;
                height: 100%;
              "
            >
              <div>
                <el-button
                  class="btn-operation"
                  type="success"
                  @click="pass(1)"
                >
                  代采审核
                </el-button>
              </div>
              <div>
                <el-button class="btn-operation" type="danger" @click="reject">
                  驳回
                </el-button>
              </div>
            </div>
          </el-col>
          <el-col
            v-if="info && info.status == 5"
            :span="4"
            style="height: 200px"
          >
            <div
              style="
                display: flex;
                flex-direction: column;
                justify-content: space-around;
                align-items: center;
                height: 100%;
              "
            >
              <div>
                <el-button class="btn-operation" type="success" @click="repay">
                  重新激活
                </el-button>
              </div>
              <div>
                <el-button
                  class="btn-operation"
                  type="danger"
                  @click="rejectPayFailOrder"
                  >驳回</el-button
                >
              </div>
            </div>
          </el-col>
        </el-row>
      </el-row>
    </el-row>

    <el-row>
      <el-col :span="24">
        <div class="card-title">操作信息</div>
        <el-table
          :key="'table3'"
          :data="logs"
          border
          style="width: 100%"
          height="400"
        >
          <el-table-column prop="action_admin" label="操作人" align="center">
          </el-table-column>
          <el-table-column prop="action_type" label="操作方式" align="center">
          </el-table-column>
          <el-table-column prop="action_result" label="结果" align="center">
          </el-table-column>
          <el-table-column prop="create_time" label="操作时间" align="center">
          </el-table-column>
          <el-table-column prop="action_desc" label="备注" align="center">
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>

    <div v-if="UpdatePayeeVisible">
      <update-payee
        :id="form.id"
        :payee="payee"
        :url="url2"
        @onCloseDialog="onCloseDialog"
      ></update-payee>
    </div>

    <el-dialog
      title="以下商品款号有改动,请审核"
      :visible.sync="khVisible"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-table :data="change_kh">
        <el-table-column
          property="goods_name"
          label="商品名称"
          align="center"
        ></el-table-column>
        <el-table-column
          property="old_kh"
          label="原款号"
          align="center"
        ></el-table-column>
        <el-table-column
          property="goods_kh"
          label="申请修改款号"
          align="center"
        ></el-table-column>
        <el-table-column fixed="right" label="操作">
          <template #default="scope">
            <el-radio v-model="scope.row.status" label="1">同意</el-radio>
            <el-radio v-model="scope.row.status" label="2">不同意</el-radio>
          </template>
        </el-table-column>
      </el-table>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="checkKh">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import UpdatePayee from "@/pages/wcgorder/components/UpdatePayee.vue";
import { listActivityGoodsByOrder } from "@/controller/purchaseGoods.js";
import * as vendorProfitConcessionApi from "@/controller/vendorProfitConcession3461.js";
import apiBaseURL from "@/utils/baseUrl.js";

const CG_TYPT_REGULAR_PICK = "13";
export default {
  name: "PurchaseOrderDetail",
  components: {
    UpdatePayee,
  },
  data() {
    return {
      CG_TYPT_REGULAR_PICK,
      form: {
        pay_account: "",
        pay_bank: "",
        pay_contact: "",
        pay_remark: "",
      },
      checkedData: [],
      typeOption: [
        {
          val: 1,
          label: "少给",
        },
        {
          val: -1,
          label: "多给",
        },
      ],
      dialogVisible1: false,
      info: {},
      logs: null,
      source: null,
      //   steps_label: null,
      textarea: "",
      loading: false,
      files: [],
      dialogGoods: null,
      editable: false,
      index: null,
      paytime: "",
      initData: "",
      pay_fail_msg: "",
      diffPriceType: 0,
      diff_price: 0.0,
      UpdatePayeeVisible: false,
      url2: "/erp/WcgOrder/updatePayee",
      payee: {},
      change_kh: [],
      khVisible: false,
      change_kh_op: [],

      // 活动费用明细表格的相关变量
      activity_fee_detail: {
        list: [], // 列表
        // total_amout: '0.00', // 活动费用总和
        rows_span_mark: {
          // 用于标记合并行数的变量
          special: {}, // 专场列需要合并的行数, 以rowIndex为下标
          sku: {}, // sku列需要合并的行数, 以rowIndex为下标
        },
      },
      // 活动费商品抵扣
      activityGoodsInfo: [],
      activity_fee_amount: "",
      rebateData: {},
      action: `${apiBaseURL}/erp/Common/erpUploadFile`,
      // 折叠
      toggle: {
        activityServiceTogglle: false, // 活动服务费商品
        activityCostTogglle: false, // 活动费抵扣商品
        concedeBenefitsToggle: false, // 让利佣金账单抵扣明细
        goodsToggle: false, // 商品抵扣列表
      },
    };
  },
  computed: {
    filteredFiles() {
      const arr = [];
      this.files.forEach((v) => {
        arr.push(v.response.data.files[0]);
      });
      return arr;
    },
  },
  //   beforeRouteEnter(to, from, next) {
  //     next(vm => {
  //         if (!vm.info) {
  //             vm.fetchData();
  //         }
  //     });
  //   },
  created() {
    this.fetchData();
  },
  methods: {
    toggleFilter(params) {
      this.toggle[params] = !this.toggle[params];
    },
    checkKh() {
      this.$confirm("确定审核?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          this.$http
            .post("/erp/WcgOrder/checkKh", {
              change_kh: this.change_kh,
            })
            .then((res) => {
              this.loading = false;
              if (res.data.code !== 200) {
                this.$message.error(res.data.msg);
              } else {
                this.$message.success(res.data.msg);
                this.khVisible = false;
                this.fetchData();
              }
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    repay() {
      this.$confirm("确定激活账单到待付款状态?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        center: true,
      })
        .then(() => {
          const args = {
            woid: this.$route.params.id,
            check_desc: this.textarea,
          };

          this.$http.post("/erp/WcgOrder/repay", args).then((res) => {
            this.loading = false;
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
            } else {
              this.$message.success(res.data.msg);
              this.fetchData();
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    update_payee() {
      this.payee.pay_contact = this.info.pay_contact;
      this.payee.pay_bank = this.info.pay_bank;
      this.payee.pay_account = this.info.pay_account;
      this.payee.pay_remark = this.info.pay_remark;
      this.payee.cnap = this.info.cnap;
      this.form.id = this.info.woid;
      this.UpdatePayeeVisible = true;
    },
    onCloseDialog() {
      this.UpdatePayeeVisible = false;
      this.fetchData();
    },
    checkedChange(e) {
      if (e.length === 1) {
        const val = e[0];
        this.diffPriceType = val;
      }
      if (e.length === 0) {
        this.diff_price = 0.0;
        this.diffPriceType = 0;
      }
      this.fixPrice();
    },
    isDisabled() {
      return false;
    },
    fixDiffPrice() {
      if (this.info.status != 0) {
        this.$message.info("只有财务待审核才可以编辑差价");
        return;
      }
      if (this.diffPriceType != -1 && this.diffPriceType != 1) {
        this.diff_price = 0.0;
        this.$message.info("请选择类型");
        return;
      }
      const patrn = /^\d+(\.\d+)?$/;
      if (!patrn.test(this.diff_price)) {
        this.diff_price = 0.0;
        this.$message.info("请输入正确的数字");
        return;
      }
      if (this.diff_price < 0) {
        this.diff_price = 0.0;
        this.$message.info("请输入大于0的数字");
        return;
      }
      const diffPrice = Number(parseFloat(this.diff_price).toFixed(2));
      if (Number.isNaN(diffPrice)) {
        this.diff_price = 0.0;
        this.$message.info("请重新输入");
        return;
      }
      this.diff_price = diffPrice;
      this.fixPrice();
    },
    fixPrice() {
      const diff = Number(this.diff_price) * Number(this.diffPriceType);
      const price =
        Number(this.info.create_price) -
        (Number(this.info.ded_price) + Number(diff));
      this.info.pay_price = parseFloat(price).toFixed(2);
    },
    showXhhkReceipt() {
      this.dialogVisible1 = true;
    },
    isXhhk(type) {
      const cgType = type;
      if (cgType == 3 || cgType == 4) {
        return true;
      }
      return false;
    },
    confirmUpload() {
      const uploadUrl = "/erp/WcgOrder/uploadReceiptOfOrderPay";
      const uploadArgs = {
        woid: this.$route.params.id,
        files: this.filteredFiles,
      };
      this.$http.post(uploadUrl, uploadArgs).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
          this.files = [];
        } else {
          this.files = [];
          this.$message({
            message: "上传成功",
            type: "success",
          });
          setTimeout(() => {
            this.fetchData();
          }, 200);
        }
      });
    },
    update(val, index) {
      const item = this.info.goodsList[index];
      const { woiid } = item;
      const { price } = item;

      if (Number(this.initData) == Number(price)) {
        return;
      }

      this.$confirm("确定修改价格?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          const url = "/erp/WcgOrder/updatePrice";
          const args = {
            woiid,
            price,
          };
          this.$http.post(url, args).then((res) => {
            if (res.data.code !== 200) {
              this.$message.error(res.data.msg);
              this.fetchData();
            } else {
              this.$message({
                type: "success",
                message: "修改成功!",
              });
              this.fetchData();
              this.initData = "";
            }
          });
        })
        .catch(() => {
          this.fetchData();
          this.$message({
            type: "info",
            message: "已取消修改",
          });
          this.initData = "";
        });
    },
    updatePaytime(index) {
      this.index = this.index == null ? index : null;

      if (this.paytime) {
        const args = {
          datetime: this.paytime,
          woid: this.$route.params.id,
        };
        const url = "/erp/WcgOrder/updatePayTime";
        this.$http.post(url, args).then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.fetchData();
          }
          this.paytime = "";
          this.index = null;
        });

        this.index = null;
        this.paytime = "";
      }
    },
    edit() {
      this.editable = !this.editable;
    },
    reject() {
      const url = "/erp/WcgOrder/rejectOrder";
      const args = {
        woid: this.$route.params.id,
        check_desc: this.textarea,
      };

      const promise = new Promise((resolve) => {
        this.$confirm("此操作将驳回订单, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$http.post(url, args).then((res) => {
              if (res.data.code !== 200) {
                this.$message.error(res.data.msg);
                return resolve({ code: 400 });
              }
              this.$notify({
                title: "操作成功",
                message: "已驳回该代采订单",
                type: "success",
              });
              return resolve({ code: 200 });
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消操作",
            });
            return resolve({ code: 400 });
          });
      });

      promise.then((res) => {
        if (res.code == 200) {
          this.fetchData();
        }
      });
    },
    rejectPayFailOrder() {
      const url = "/erp/WcgOrder/rejectPayFailOrder";
      const args = {
        woid: this.$route.params.id,
        check_desc: this.textarea,
      };

      const promise = new Promise((resolve) => {
        this.$confirm("此操作将驳回订单, 是否继续?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$http.post(url, args).then((res) => {
              if (res.data.code !== 200) {
                this.$message.error(res.data.msg);
                return resolve({ code: 400 });
              }
              this.$notify({
                title: "操作成功",
                message: "已驳回该代采订单",
                type: "success",
              });
              return resolve({ code: 200 });
            });
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消操作",
            });
            return resolve({ code: 400 });
          });
      });

      promise.then((res) => {
        if (res.code == 200) {
          this.fetchData();
        }
      });
    },
    pass(isPurchase) {
      if (Number(this.info.pay_price) < 0) {
        this.$message.error("抵扣金额大于代采金额，请核查");
        return;
      }

      let url = "/erp/WcgOrder/checkOrder";
      if (isPurchase == 1) {
        url = "/erp/WcgOrder/purchaseCheckOrder";
      } else if (this.info.cg_type == 2) {
        url = "/erp/WcgOrder/checkOrderPrepay";
      }
      const diffPrice = Number(this.diff_price) * Number(this.diffPriceType);
      const args = {
        check_desc: this.textarea,
        woid: this.$route.params.id,
        diff_price: diffPrice,
      };
      this.$confirm("是否通过审核?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (isPurchase != 1) {
            this.$http
              .post("/erp/WcgOrder/checkRepeat", {
                woid: this.$route.params.id,
              })
              .then((res) => {
                if (res.data.code !== 200) {
                  this.$message.error(res.data.msg);
                } else if (res.data.data.is_repeat == 1) {
                  this.$confirm("今天有相同金额的开单记录,确定通过?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                  })
                    .then(() => {
                      this.do_pass(url, args);
                    })
                    .catch(() => {
                      this.$message({
                        type: "info",
                        message: "已取消操作",
                      });
                    });
                } else {
                  this.do_pass(url, args);
                }
              });
          } else {
            this.do_pass(url, args);
          }
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 执行审核
    do_pass(url, args) {
      this.$http.post(url, args).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.$notify({
            title: "操作成功",
            message: "已通过该代采订单",
            type: "success",
          });
          setTimeout(() => {
            this.fetchData();
            const currentPath =
              this.$parent.$parent.$parent.$parent.filterUriPrefix(
                this.$route.path
              );
            this.$parent.$parent.$parent.$parent.removeTab(currentPath);
          }, 300);
        }
      });
    },
    handleRemove(file) {
      const index = this.files.indexOf(file.response.data.files[0]);
      if (index > -1) {
        this.files.splice(index, 1);
      }
    },
    handleExceed(files, fileList) {
      this.$message.warning(
        `当前限制选择 9 个文件，本次选择了 ${files.length} 个文件，共选择了 ${
          files.length + fileList.length
        } 个文件`
      );
    },
    handleEdit() {
      const { id } = this.$route.params;
      if (!parseInt(id, 10)) {
        this.$message.error("传入id有误");
        return;
      }
      this.$router.push(`/home/purchasing/orderedit/${id}`);
    },

    uploadSuccess(res, file, fileList) {
      if (res.code !== 200) {
        this.$message.error(res.data.msg);
      } else {
        // this.files = this.files.concat(res.data.files);
        this.files = fileList;
      }
    },
    fetchData() {
      const url = "/erp/WcgOrder/getOrderInfo";
      const args = {
        woid: this.$route.params.id,
      };

      // 判断有没有修改款号的申请
      //   this.loading = true;
      this.$http.post("/erp/WcgOrder/hasChangeKh", args).then((res) => {
        // this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.change_kh = res.data.data.change_kh;
          this.getActivityGoodsInfo();
          if (this.change_kh.length) {
            this.khVisible = true;
          }
        }
      });

      //   this.loading = true;
      this.$http.post(url, args).then((res) => {
        // this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.info = res.data.data.info;
          this.toggle.goodsToggle =
            this.info.ded.goodsList &&
            Array.isArray(this.info.ded.goodsList) &&
            this.info.ded.goodsList.length > 0;
          this.source = res.data.data.info.source;
          //   this.steps_label = res.data.data.info.steps_label;
          if (
            (this.info.status < 2 || this.info.status == 9) &&
            this.info.pay_docs.length > 0
          ) {
            Object.keys(this.info.pay_docs).forEach((i) => {
              this.info.docs.push(this.info.pay_docs[i]);
            });
          }
          this.logs = res.data.data.logs;
          this.loading = false;
          this.textarea = res.data.data.info.check_desc;
          this.pay_fail_msg = res.data.data.info.pay_fail_msg;
          if (this.info.status == 5) {
            this.textarea = this.pay_fail_msg;
          }
          // 处理活动费用明细
          this.setActivityDetail(res.data.data.activity_detail);
          this.getRebateData();
        }
      });
    },
    /**
     *activity_fee_detail: {
        list: [], // 列表
        total_amout: '0.00', // 活动费用总和
        rows_span_mark: { // 用于标记合并行数的变量
          special: {}, // 专场列需要合并的行数, 以rowIndex为下标
          sku: {}, // sku列需要合并的行数, 以rowIndex为下标
        }
      },
     */
    setActivityDetail(data) {
      if (data.list.length == 0) return;
      const list = [];
      let commonIndex = 0; // 计算循环次数
      // total_amout = 0; // 总活动费用
      data.list.forEach((special) => {
        // console.log(special);
        special.detail.forEach((v, index) => {
          // sku
          const tempIndex = commonIndex;
          v.sku.forEach((skuRow, skuIndex) => {
            // 活动
            this.activity_fee_detail.rows_span_mark.sku[commonIndex] =
              skuRow.detail.length;
            skuRow.detail.forEach((activity) => {
              /* eslint no-param-reassign: ["error", { "props": false }] */
              const skuKey = `${special.goods_no}-${skuRow.co_val}-${skuRow.si_val}-${skuRow.woiid}`;
              activity.special_index = index;
              activity.sku_index = skuIndex;
              activity.special_start_time = v.special_start_time; // 专场开始时间
              activity.num = skuRow.num; // 开单数量
              activity.co_val = skuRow.co_val;
              activity.si_val = skuRow.si_val;
              activity.goods_name = special.goods_name;
              activity.goods_no = special.goods_no;
              activity.price = data.sku_price[skuKey];
              list.push(activity);
              commonIndex += 1;
            });
          });
          this.activity_fee_detail.rows_span_mark.special[tempIndex] =
            commonIndex - tempIndex;
        });
        // total_amout += Number(special.goods.activity_fee);
      });
      // this.activity_fee_detail.total_amout = parseFloat(total_amout).toFixed(2);
      this.activity_fee_detail.list = list;
      this.toggle.activityServiceTogglle =
        this.activity_fee_detail.list &&
        Array.isArray(this.activity_fee_detail.list) &&
        this.activity_fee_detail.list.length > 0;
    },

    // 活动明细表的处理
    rowSpan({ rowIndex, columnIndex }) {
      // sku和数量也要合并
      if ([1, 2, 3, 4, 5, 6].includes(columnIndex)) {
        if (
          typeof this.activity_fee_detail.rows_span_mark.sku[rowIndex] !==
          "undefined"
        ) {
          return [this.activity_fee_detail.rows_span_mark.sku[rowIndex], 1];
        }
        // 显示行 不显示列
        return [1, 0];
      }
      // 第一列专场时间肯定要合并的,
      if (columnIndex == 0) {
        if (
          typeof this.activity_fee_detail.rows_span_mark.special[rowIndex] !==
          "undefined"
        ) {
          return [this.activity_fee_detail.rows_span_mark.special[rowIndex], 1];
        }
        return [1, 0];
      }
      return [1, 1];
    },
    // 获取活动抵扣商品
    getActivityGoodsInfo() {
      const params = {
        woid: this.$route.params.id,
      };
      listActivityGoodsByOrder(params)
        .then((data) => {
          const {
            goods_list: goodsList,
            activity_fee_amount: activityFeeAmount,
          } = data;
          this.activityGoodsInfo = goodsList;
          this.activity_fee_amount = activityFeeAmount;
          this.toggle.activityCostTogglle =
            this.activityGoodsInfo &&
            Array.isArray(this.activityGoodsInfo) &&
            this.activityGoodsInfo.length > 0;
        })
        .catch(this.$noop);
    },
    exportActivityGoods() {
      const params = {
        is_excel: 1,
        woid: this.$route.params.id,
      };

      this.$http
        .post("/erp/WcgOrder/listActivityGoodsByOrder", params)
        .then((res) => {
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        });
    },
    // 获取让利数据
    getRebateData() {
      vendorProfitConcessionApi
        .listWoReturnProfitBillDetail({
          woid: this.$route.params.id,
        })
        .then((res) => {
          this.rebateData = res;
          this.toggle.concedeBenefitsToggle =
            this.rebateData.list &&
            Array.isArray(this.rebateData.list) &&
            this.rebateData.list.length > 0;
        })
        .catch(this.$noop);
    },
  },
};
</script>

<style scoped>
.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}

.card-title {
  background: #f3f3f3;
  height: 30px;
  line-height: 30px;
  padding: 0 25px;
  cursor: pointer;
}

.card-warning {
  background: #e8aae1;
  height: 30px;
  line-height: 30px;
  padding: 0 25px;
}

.viewer {
  border: 1px solid #ddd;
  overflow: scroll;
  height: 928px;
}

.btn-operation {
  width: 100px;
}

.upload-demo {
  display: inline-block;
  vertical-align: middle;
}

.highlight {
  color: red;
}

.pay-comment >>> textarea {
  color: #ff4040 !important;
}

.el-tag--warning {
  background-color: rgb(255, 218, 114);
}
</style>



// WEBPACK FOOTER //
// src/pages/PurchaseOrderDetail.vue